module.exports = "<div class=\"container app-container account-main-subview\">\n    <div class=\"row account-categories account-tiles\"></div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/account/landing.html
// module id = 762
// module chunks = 7